import axiosInstance from "../hooks/axiosInstance";

export const makeRequest = async (
  url: string,
  method: string,
  data: any,
  requiredAuth: boolean = false,
): Promise<any> => {
  let tokenResponse: any = null;

  if (requiredAuth) {
    tokenResponse = await axiosInstance.request({
      data: {
        platform_code: import.meta.env.VITE_PLATFORM_CODE,
      },
      method: "POST",
      url: "/api/request-access",
    });
  }

  if (
    requiredAuth == true &&
    tokenResponse &&
    tokenResponse.data.status == true
  ) {
    axiosInstance.defaults.headers.common["Auth-Api-Key"] =
      tokenResponse.data.response.access_code;
  }

  return await axiosInstance
    .request({
      data: data,
      method,
      url,
    })
    .then((response) => {
      let status = true;

      if (response && response.data && response.data.success) {
        status = response.data.success;
      }

      return {
        status: status,
        data: response.data,
      };
    })
    .catch((error) => {
      return {
        status: false,
        data:
          error.response?.data?.message ??
          "An error occurred. Please try again.",
      };
    });
};
